var React = require('react');
var mui = require('material-ui');
var PayloadStates = require('../constants/PayloadStates');
import {green300, grey300, red300} from 'material-ui/styles/colors';

module.exports = lore.connect(function(getState, props) {
  return {
    ports: getState('port.find')
  }
})(
React.createClass({
  displayName: 'Ports',

  propTypes: {
    ports: React.PropTypes.object.isRequired,
    isTesting: React.PropTypes.bool.isRequired,
    onTestComplete: React.PropTypes.func.isRequired,
  },

  getInitialState: function() {
    return {
      isComplete: false
    }
  },

  componentWillReceiveProps: function(nextProps) {
    var ports = nextProps.ports;
    var completed = this.getCompletedTests(ports);
    var failed = this.getFailedTests(ports);

    if (ports.data.length === completed && !this.state.isComplete) {
      this.props.onTestComplete(ports, failed);
      this.setState({
        isComplete: true
      })
    }
  },

  getCompletedTests: function(ports) {
    var count = 0;

    ports.data.map(function(port) {
      if (port.state !== PayloadStates.FETCHING) {
        count = count + 1;
      }
    });

    return count;
  },

  getFailedTests: function(ports) {
    var count = 0;

    ports.data.map(function(port) {
      if (port.state === PayloadStates.ERROR_FETCHING) {
        count = count + 1;
      }
    });

    return count;
  },

  render: function() {
    var isTesting = this.props.isTesting;
    var ports = this.props.ports;
    var completed = this.getCompletedTests(ports);
    var failed = this.getFailedTests(ports);
    var testingComplete = (ports.data.length > 0 && completed === ports.data.length);

    var backgroundColor = grey300;
    var progressColor = null;

    var avatar = isTesting ? (
      <mui.CircularProgress />
    ) : (
      <mui.Avatar backgroundColor={backgroundColor}>
        ?
      </mui.Avatar>
    );

    if (testingComplete) {
      if (failed > 0) {
        backgroundColor = red300;
        avatar = (
          <mui.Avatar
            backgroundColor={backgroundColor} />
        );
      } else {
        backgroundColor = green300;
        avatar = (
          <mui.Avatar
            backgroundColor={backgroundColor} />
        );
      }
    }

    var primaryText = isTesting ? (
      completed + ' of ' + ports.data.length + ' tests complete / ' + failed + ' failed'
    ) : 'Waiting to begin test...';

    return (
      <mui.Paper>
        <mui.List>
          <mui.ListItem
            disabled={true}
            leftAvatar={avatar}
            primaryText={primaryText}
            secondaryText={(
              <mui.LinearProgress
                mode="determinate"
                color={testingComplete ? backgroundColor : null}
                style={{height: '4px', marginTop: '8px'}}
                min={0}
                max={ports.data.length > 0 ? ports.data.length : 100}
                value={completed} />
            )}
          />
        </mui.List>
      </mui.Paper>
    );
  }
})
);



// WEBPACK FOOTER //
// ./src/components/Ports.js